/**
 *  @class
 *  @function CustomBundles
 */
if (!customElements.get('custom-bundles')) {
  customElements.define('custom-bundles', class CustomBundles extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.elements = {
        form: this.querySelector('form'),
        bundleWrapper: this.querySelector('[data-bundle-steps]'),
        bundleProductContainers: this.querySelectorAll('[data-bundle-item]'),
        nextSteps: this.querySelectorAll('[data-next-step]'),
        prevtSteps: this.querySelectorAll('[data-prev-step]'),
        finalStep: this.querySelector('[data-bundle-item-checkout]'),
        checkoutStepBtn: this.querySelector('[data-checkout-step]'),
        variantSelects: this.querySelectorAll('variant-selects-bundle'),
        allVariantSelection: this.querySelectorAll('[data-bundle-item-checkout] select'),
        bundleTotalPrice: this.querySelector('[data-bundle-total-price]'),
        submitButton: this.querySelector('[data-bundle-add-to-cart]'),
        bundleAddonsSubmit: this.querySelectorAll('[data-bundle-product-addon]'),
        bundleCheckoutForm: this.querySelector('#bundleCheckoutForm'),
        bundleScrollableWrapper: this.querySelector('#bundleCheckoutForm .model-main-content'),
      }
      this.elements.form?.addEventListener('submit', this.onsubmit.bind(this)),
      this.elements.nextSteps?.forEach(el => el.addEventListener('click', this.changeSteps.bind(this)));
      this.elements.prevtSteps?.forEach(el => el.addEventListener('click', this.changeSteps.bind(this)));
      this.elements.checkoutStepBtn?.addEventListener('click', this.activateCheckoutModel.bind(this));
      this.elements.variantSelects?.forEach(el => el.addEventListener('change', this.changeVariants.bind(this)));
      this.elements.allVariantSelection?.forEach(el => el.addEventListener('change', this.calculateTotalPrice.bind(this)));
      this.elements.bundleAddonsSubmit?.forEach(el => el.addEventListener('click', this.addOrRemoveAddon.bind(this)));
      this.elements.bundleScrollableWrapper?.addEventListener('scroll', this.checkScrolling.bind(this));
    }

    checkScrolling = (event) => {
      if (this.elements.bundleScrollableWrapper.scrollTop + this.elements.bundleScrollableWrapper.clientHeight >= (this.elements.bundleScrollableWrapper.scrollHeight - 30)) {
          this.elements.bundleCheckoutForm.classList.remove('has-scroll');
      } else {
          this.elements.bundleCheckoutForm.classList.add('has-scroll');
      }
    }

    changeSteps = (event) => {
      var nextStep = event.target.hasAttribute('data-next-step') ? event.target.getAttribute('data-next-step') : event.target.getAttribute('data-prev-step');
      this.elements.bundleWrapper?.setAttribute('data-bundle-steps', nextStep);
      this.elements.finalStep?.classList.add('d-none');
      this.elements.bundleProductContainers?.forEach(item => item.classList.add('d-none'));
      this.elements.bundleWrapper?.querySelector(`[data-bundle-item="${nextStep}"]`)?.classList.remove('d-none');
      window.dispatchEvent(new Event('resize'));
    }

    activateCheckoutModel = () => {
      this.elements.bundleProductContainers?.forEach(item => item.classList.add('d-none'));
      this.elements.finalStep?.classList.remove('d-none');
    }

    changeVariants = async (event) => {
      var el = event.currentTarget;
      var product_id = el?.getAttribute('data-item-id');
      var selected_variant = el?.querySelector('input:checked')?.value;
      var selctionList = this.elements.finalStep?.querySelector(`select[data-item-id="${product_id}"]`)
      if(selctionList) selctionList.value = selected_variant;
      this.calculateTotalPrice();

      var variantSlider = el?.closest("[data-bundle-item]")?.querySelector(`[data-variant-slider="${selected_variant}"]`);
      if(!variantSlider) {
        var product_handle = el?.getAttribute('data-item-handle');
        const res = await fetch(`/products/${product_handle}?variant=${selected_variant}&view=variant-images`);
        const html = await res.text();
        var imageWrapper = el?.closest("[data-bundle-item]")?.querySelector('.product-img-wrappers');
        if (imageWrapper) {
          imageWrapper.insertAdjacentHTML('beforeend', html);
        }
      }
      // this.querySelector('.thb-product-detail').scrollTop = 0;
      var currentSlider;
      if (el?.closest("[data-bundle-item]")?.querySelector(`[data-variant-slider="${selected_variant}"] product-slider img`)) {
        el?.closest("[data-bundle-item]")?.querySelectorAll(`[data-variant-slider]`).forEach(el => el.classList.add('d-none'))
        el?.closest("[data-bundle-item]")?.querySelectorAll(`[data-item-default-slider]`).forEach(el => el.classList.add('d-none'))
        el?.closest("[data-bundle-item]")?.querySelectorAll(`[data-variant-slider="${selected_variant}"]`).forEach(el => el.classList.remove('d-none')); 
        currentSlider = el?.closest("[data-bundle-item]")?.querySelector(`[data-variant-slider="${selected_variant}"]`);
      } else {
        el?.closest("[data-bundle-item]")?.querySelectorAll(`[data-variant-slider]`).forEach(el => el.classList.add('d-none'))
        el?.closest("[data-bundle-item]")?.querySelectorAll(`[data-item-default-slider]`).forEach(el => el.classList.remove('d-none'))
        currentSlider = el?.closest("[data-bundle-item]")?.querySelector(`[data-item-default-slider]`);
      }
      window.dispatchEvent(new Event('resize'));
      // setTimeout(() => {
      //   var scrollTop = this.querySelector('model-component')?.scrollTop;
      // currentSlider.closest('.thb-product-detail') && (currentSlider.closest('.thb-product-detail').scrollTo(0, 100));
      // }, 1000);
      // currentSlider.closest('.model-main-content').style.height = 'auto';
      // setTimeout(() => {
      //   currentSlider.closest('.model-main-content').style.height = '';
      // }, 1);
      // var pSlider = currentSlider.querySelector('product-slider');
      // if (pSlider) {
      //   pSlider.reInit(0);
      // }
    }

    calculateTotalPrice = () => {
      this.totalPrice = parseInt(this.querySelector('[data-bundle-variant-price]')?.getAttribute('data-bundle-variant-price')) || 0;
      this.elements.allVariantSelection?.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        this.totalPrice += parseInt(selectedOption.getAttribute('data-price')) || 0;
      })
      this.elements.bundleAddonsSubmit?.forEach(item => {
        var isSelected = item.getAttribute('data-selected');
        if(isSelected == "true") {
          this.totalPrice += parseInt(item.getAttribute('data-variant-price')) || 0;
        }
      })
      var moneyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
      this.elements.bundleTotalPrice && (this.elements.bundleTotalPrice.innerHTML = formatMoney(this.totalPrice, moneyFormat));
      console.log(this.elements.bundleTotalPrice.innerHTML);
    }

    addOrRemoveAddon = (event) => {
      var btn = event.currentTarget;
      if(!btn) return false;
      var isAdded = btn.getAttribute('data-selected');
      if (isAdded == "true") {
        btn.setAttribute('data-selected', false);
        btn.closest('[data-bundle-product-addon-action]')?.querySelectorAll('.variant-add-to-cart-data input').forEach(input => input.setAttribute('disabled', 'disabled'));
      } else {
        btn.setAttribute('data-selected', true);
        btn.closest('[data-bundle-product-addon-action]')?.querySelectorAll('.variant-add-to-cart-data input').forEach(input => input.removeAttribute('disabled'));
      }
      this.calculateTotalPrice();
    }

    onsubmit = (event) => {
      event.preventDefault();
      this.elements.submitButton.setAttribute('aria-disabled', true);
      this.elements.submitButton.classList.add('loading');

      let formData = new FormData(this.elements.form);
      const payload = window.serializeCartAddPayload(formData);
      payload.sections = this.getSectionsToRender().map((section) => section.section);
      payload.sections_url = window.location.pathname;

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      };

      fetch(`${theme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          dispatchCustomEvent('product:variant-error', {
            source: 'product-form',
            productVariantId: payload.items && payload.items[0] ? payload.items[0].id : undefined,
            errors: response.description,
            message: response.message
          });
          return;
        }

        this.renderContents(response);

        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.elements.submitButton.classList.remove('loading');
        this.elements.submitButton.removeAttribute('aria-disabled');
        this.querySelector("model-component")?.classList.remove('active');
        document.body?.classList.remove('open-cc--product');
      });
    }
    
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
        window.updateCartJson();
      }
      this.elements.bundleWrapper?.setAttribute('data-bundle-steps', 1);
      this.elements.finalStep?.classList.add('d-none');
      this.elements.bundleProductContainers?.forEach(item => item.classList.add('d-none'));
      this.elements.bundleWrapper?.querySelector(`[data-bundle-item="1"]`)?.classList.remove('d-none');
      window.dispatchEvent(new Event('resize'));
    }
    
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  });
}
